module.exports = __webpack_public_path__ + "img/drug-23.be562cd4.png";